import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { TerroristOrganization } from '@/types';
import { useDeleteTerroristOrganizationMutation } from '@/services';

export interface DeleteTerroristOrganizationProps extends DialogProps {
  terroristOrganization: TerroristOrganization;
  onClose(): void;
}

const DeleteTerroristOrganization: React.FC<DeleteTerroristOrganizationProps> = ({
  terroristOrganization,
  onClose,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteTerroristOrganization, deleteTerroristOrganizationResponse] = useDeleteTerroristOrganizationMutation();

  async function handleDeleteTerroristOrganization() {
    try {
      await deleteTerroristOrganization(terroristOrganization).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{terroristOrganization?.name.ru}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{terroristOrganization?.name.ru}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteTerroristOrganizationResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteTerroristOrganizationResponse.isLoading}
          size="small"
          onClick={handleDeleteTerroristOrganization}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTerroristOrganization;
